import { Component } from "@angular/core";
import { ApiPublicProfile, UsersApi } from "@tytapp/api";
import { DialogComponent } from "@tytapp/common/dialog-component";
import { NamedDialog, PageService, Shell } from "@tytapp/common";
import * as SpotIMIntegration from "./spotim-integration";

@NamedDialog('spot-profile')
@Component({
    selector: 'app-spot-profile',
    templateUrl: './spot-user-profile.component.html',
    styleUrls: ['./spot-user-profile.component.scss']
})
export class SpotUserProfileComponent extends DialogComponent {
    constructor(
        private userApi: UsersApi,
        pageService: PageService
    ) {
        super(pageService);
    }

    spotUser: SpotIMIntegration.SpotUser;
    publicProfile: ApiPublicProfile;

    async init(spotUser: SpotIMIntegration.SpotUser) {
        this.spotUser = spotUser;
        this.loadUser(); // intentional lack of await
    }

    async loadUser() {
        // useful for debugging locally since spotim doesnt load
        // there
        // __SPOTIM__.initApp('user-profile', {"user":{"id":"u_PMlyH9lB3SjO","displayName":"Arthur","imageId":"#Olive-Controller","username":"Arthur092","isModerator":false,"isRegistered":true,"isSuperAdmin":false,"isCommunityModerator":false,"isJournalist":false,"isAdmin":false,"isFallbackUser":false,"reputation":{"total":10,"receivedRankedUp":1},"ssoData":{},"isOnline":false,"isMuted":false},"postId":"postId","mode":"main"})

        if (!this.spotUser) {
            this.shell.hideDialog();
            return;
        }

        try {
            let result = await this.userApi.translateSpotUserID(this.spotUser.id).toPromise();
            this.publicProfile = await this.userApi.getPublicProfile(result.username).toPromise();
        } catch (e) {
            if (e.json)
                e = e.json();

            console.error("Failed to translate spotim user ID to TYT:");
            console.error(e);
            console.error(`Falling back to Spot.im`);
            SpotIMIntegration.showSpotProfile(this.spotUser);
            this.shell.hideDialog();
        }
    }

    hide() {
        this.shell.hideDialog();
    }

    showSpotHistory() {
        SpotIMIntegration.showSpotProfile(this.spotUser);
    }
}